import service from './baseService';

export const getAbsenceTypes = () => {
    return service.get('/absence-types');
};

export const getScheduleRequests = () => {
    return service.get('/schedule-requests', { params: { type: 'timeoff' } });
};

export const createScheduleRequest = (payload) => {
    return service.post('/schedule-requests', payload);
};

export const getAvailabilityRequests = () => {
    return service.get('/schedule-requests', { params: { type: 'availability' } });
};

export const updateScheduleRequest = (id, payload) => {
    return service.put(`/schedule-requests/${id}`, payload);
};

export const deleteScheduleRequest = (id) => {
    return service.delete(`/schedule-requests/${id}`);
};
